import { FilterBar, SelectV2, SortDropdownValue } from "@/modules/common/components";
import { EntityFilterBar, UseFiltersResult } from "@/modules/common/filters";
import {
  LEAD_ORIGIN_OPTIONS,
  LEAD_SORT_OPTIONS,
  LEAD_STATUS_OPTIONS,
  LeadOrigin,
  LeadSortField,
  LeadStatus,
} from "@/modules/common/types/Leads.enum";

import { LEAD_FILTER_FIELDS, LeadFilters } from "../constants/LeadFilterFields";

interface LeadsFilterBarProps {
  filters: UseFiltersResult<LeadFilters>;
  sort: SortDropdownValue<LeadSortField> | null;
  onSortChange: (sort: SortDropdownValue<LeadSortField> | null) => void;
}

const LeadsFilterBar = ({ filters, sort, onSortChange }: LeadsFilterBarProps) => (
  <EntityFilterBar
    filters={filters}
    sort={sort}
    onSortChange={onSortChange}
    sortOptions={LEAD_SORT_OPTIONS}
    filterFields={LEAD_FILTER_FIELDS}
    modalTitle="Filtrar Leads"
    searchPlaceholder="Buscar por nome, empresa ou e-mail"
  >
    <FilterBar.Item>
      <SelectV2
        mode="multiple"
        placeholder="Status"
        options={LEAD_STATUS_OPTIONS}
        value={filters.values.status}
        onChange={(next) => filters.setValue("status", next?.length ? (next as LeadStatus[]) : undefined)}
      />
    </FilterBar.Item>

    <FilterBar.Item>
      <SelectV2
        mode="multiple"
        placeholder="Origem"
        options={LEAD_ORIGIN_OPTIONS}
        value={filters.values.origin}
        onChange={(next) => filters.setValue("origin", next?.length ? (next as LeadOrigin[]) : undefined)}
      />
    </FilterBar.Item>
  </EntityFilterBar>
);

export default LeadsFilterBar;
